
import { getDoc, doc, collection, getDocs, updateDoc } from "firebase/firestore";
import { db } from "./firebase";

export const getCachedRoster = async (teamId) => {
  if (!teamId) throw new Error("Missing team ID");


  const teamRef = doc(db, "teams", teamId);
  const teamSnap = await getDoc(teamRef);
  const serverVersion = teamSnap.data()?.rosterVersion || 0;


  const localVersion = Number(localStorage.getItem("cachedRosterVersion") || 0);
  if (localVersion < serverVersion) {

    localStorage.removeItem("cachedRoster");
    localStorage.setItem("cachedRosterVersion", String(serverVersion));
  }


  const localData = localStorage.getItem("cachedRoster");
  if (localData) {
    return JSON.parse(localData);
  }


  const rosterRef = collection(db, "teams", teamId, "Roster");
  const snapshot = await getDocs(rosterRef);
  const newRoster = snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data()
  }));

  localStorage.setItem("cachedRoster", JSON.stringify(newRoster));
  localStorage.setItem("cachedRosterVersion", String(serverVersion));
  return newRoster;
};

export const clearCachedRoster = () => {
  localStorage.removeItem("cachedRoster");
  localStorage.removeItem("cachedRosterVersion");
};

export const bumpRosterVersion = async (teamId) => {
  if (!teamId) return;
  const teamRef = doc(db, "teams", teamId);

  await updateDoc(teamRef, {
    rosterVersion: ((await getDoc(teamRef)).data()?.rosterVersion || 0) + 1
  });
};